/**
 * Common page layout view property keys
 */
export enum LayoutPropKeys {
  LayoutWidth = "layout_width",
  LayoutHeight = "layout_height",
  Elevation = "elevation",
  LayoutBackgroundColor = "background",
  BackgroundImage = "backgroundImage",
  LayoutGravity = "layout_gravity"
}

/**
 * Page layout view property margin keys
 */
export enum LayoutMarginPropKeys {
  LayoutMarginTop = "layout_marginTop",
  LayoutMarginLeft = "layout_marginLeft",
  LayoutMarginRight = "layout_marginRight",
  LayoutMarginBottom = "layout_marginBottom",
}

/**
 * Page layout view property padding keys
 */
export enum LayoutPaddingPropKeys {
  LayoutPaddingTop = "paddingTop",
  LayoutPaddingLeft = "paddingLeft",
  LayoutPaddingRight = "paddingRight",
  LayoutPaddingBottom = "paddingBottom",
}

/**
 * Text view property keys
 */
export enum LayoutTextViewPropKeys {
  Width = "width",
  Height = "height",
  TextColor = "textColor",
  TextResources = "text",
  TextStyle = "textStyle",
  TextAlignment = "textAlignment",
  TextSize = "textSize",
  Gravity = "gravity",
  Typeface = "typeface"
}

/**
 * Image view property keys
 */
export enum LayoutImageViewPropKeys {
  Src = "src",
}

/**
 * Player view property keys
 */
export enum LayoutPlayerViewPropKeys {
  Src = "src",
  ShowPlaybackControls = "showPlaybackControls",
  AutoPlay = "autoPlay",
  AutoPlayDelay = "autoPlayDelay",
  ShowRewindButton = "showRewindButton",
  ShowFastForwardButton = "showFastForwardButton",
  ShowPreviousButton = "showPreviousButton",
  ShowNextButton = "showNextButton"
}

/**
 * Button property keys
 */
export enum LayoutButtonPropKeys {
  Width = "width",
  Height = "height",
  Background = "background",
  TextColor = "textColor",
  TextResources = "text",
  TextStyle = "textStyle",
  TextSize = "textSize",
  AllCaps = "allCaps",
  Gravity = "gravity"
}

/**
 * Linear layout property keys
 */
export enum LayoutLinearLayoutPropKeys {
  Orientation = "orientation",
}

/**
 * Tab layout property keys
 */
export enum LayoutTabPropKeys {
  TabMode = "tabMode",
  TabGravity = "tabGravity",
  SelectedTabIndicatorColor = "selectedTabIndicatorColor",
  SelectedTabIndicatorGravity = "selectedTabIndicatorGravity",
  SelectedTabIndicatorHeight = "selectedTabIndicatorHeight",
  TabTextColorNormal = "tabTextColorNormal",
  TabTextColorSelected = "tabTextColorSelected",
  UnboundedRipple = "unboundedRipple",
  TabIndicatorFullWidth = "tabIndicatorFullWidth",
  Data = "data",
}